import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AddAlternativePart.css';

const apiBaseURL = (process.env.REACT_APP_API_BASE_URL || 'https://api.vehiclesolution.co').replace(/\/+$/, '');

function AddAlternativePart() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [partFound, setPartFound] = useState(false);
  const [searchError, setSearchError] = useState('');
  const [form, setForm] = useState({
    PartId: '',
    Part_no: '',
    al_part1: '',
    al_part2: '',
    al_part3: '',
    al_part4: '',
    al_part5: '',
    al_part6: '',
    al_part7: '',
    al_part8: '',
    al_part9: '',
    al_part10: ''
  });

  // Search for part when Part_no changes
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setSearchError('Please login first');
      return;
    }
    
    if (form.Part_no && form.Part_no.length >= 3) {
      const timeoutId = setTimeout(() => {
        searchPartByNumber(form.Part_no);
      }, 500); // Debounce 500ms
      return () => clearTimeout(timeoutId);
    } else {
      setPartFound(false);
      setSearchError('');
      setForm(prev => ({ ...prev, PartId: '' }));
    }
  }, [form.Part_no]);

  const searchPartByNumber = async (partNo) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setSearchError('Please login first');
        return;
      }
      
      // Remove spaces from part number
      const cleanPartNo = partNo.replace(/\s+/g, '');
      
      const response = await fetch(`${apiBaseURL}/api/parts/search?Part_no=${encodeURIComponent(cleanPartNo)}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      const data = await response.json();
      
      if (response.ok && data.success && data.parts && data.parts.length > 0) {
        setForm(prev => ({ 
          ...prev, 
          PartId: data.parts[0].PartId,
          Part_no: cleanPartNo 
        }));
        setPartFound(true);
        setSearchError('');
      } else {
        setForm(prev => ({ ...prev, PartId: '' }));
        setPartFound(false);
        setSearchError('Part not found in database');
      }
    } catch (error) {
      console.error('Error searching part:', error);
      setSearchError('Error searching part: ' + error.message);
      setPartFound(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      
      // Remove spaces from all part numbers
      const formData = {
        ...form,
        Part_no: form.Part_no ? form.Part_no.replace(/\s+/g, '') : '',
        al_part1: form.al_part1 ? form.al_part1.replace(/\s+/g, '') : '',
        al_part2: form.al_part2 ? form.al_part2.replace(/\s+/g, '') : '',
        al_part3: form.al_part3 ? form.al_part3.replace(/\s+/g, '') : '',
        al_part4: form.al_part4 ? form.al_part4.replace(/\s+/g, '') : '',
        al_part5: form.al_part5 ? form.al_part5.replace(/\s+/g, '') : '',
        al_part6: form.al_part6 ? form.al_part6.replace(/\s+/g, '') : '',
        al_part7: form.al_part7 ? form.al_part7.replace(/\s+/g, '') : '',
        al_part8: form.al_part8 ? form.al_part8.replace(/\s+/g, '') : '',
        al_part9: form.al_part9 ? form.al_part9.replace(/\s+/g, '') : '',
        al_part10: form.al_part10 ? form.al_part10.replace(/\s+/g, '') : ''
      };
      
      const response = await fetch(`${apiBaseURL}/api/parts/alternative`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        alert('Alternative Part added successfully!');
        navigate('/inventory/parts');
      } else {
        alert('Error adding alternative part: ' + (data.message || 'Unknown error'));
      }
    } catch (error) {
      alert('Error: ' + error.message);
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-alt-part-container">
      <h2>Add Alternative Part#</h2>
      <form onSubmit={handleSubmit} className="add-alt-part-form">
        <div className="form-group">
          <label>Part Number</label>
          <input 
            name="Part_no" 
            placeholder="Enter Part Number to search" 
            value={form.Part_no} 
            onChange={handleChange}
            disabled={loading}
          />
          {searchError && <span className="error">{searchError}</span>}
          {partFound && <span className="success">✓ Part found (ID: {form.PartId})</span>}
        </div>
        
        <div className={`alternative-parts ${partFound ? 'enabled' : 'disabled'}`}>
          <label>Alternative Part Numbers {partFound ? '' : '(enable after part is found)'}</label>
          {[...Array(10)].map((_, i) => (
            <input
              key={i}
              name={`al_part${i+1}`}
              placeholder={`Alternative Part #${i+1}`}
              value={form[`al_part${i+1}`]}
              onChange={handleChange}
              disabled={!partFound || loading}
            />
          ))}
        </div>
        
        <button type="submit" disabled={loading || !partFound}>
          {loading ? 'Adding...' : 'Add Alternative Part'}
        </button>
        <button type="button" onClick={() => navigate('/inventory/parts')} disabled={loading}>Cancel</button>
      </form>
    </div>
  );
}

export default AddAlternativePart;
